var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 36,
    viewBox: "0 0 106 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4329 0H31.0647V36H24.2861L8.53426 15.573V36H0V0H6.68111L22.4329 20.3258V0Z",
    fill: "#1A46A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.818 36L53.0404 10.0618L42.2629 36H33.0946L49.3341 0H56.5517L72.8399 36H63.818Z",
    fill: "#1A46A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.882 0H97.2505V20.3258L81.4987 0H74.8176V36H83.3519V15.573L99.1037 36H105.882V0Z",
    fill: "#1A46A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBrand);
export default __webpack_public_path__ + "static/media/logo-brand.07103ac7e98f8326d1d3d7f239ac9c88.svg";
export { ForwardRef as ReactComponent };